import Vector3 from './Vector3';
import Vector4 from './Vector4';
import Quaternion from './Quaternion';

// Matrix indexes are as follow:
// | 0 4  8 12 |
// | 1 5  9 13 |
// | 2 6 10 14 |
// | 3 7 11 15 |

// Letters are as follow:
// | a b c d |
// | e f g h |
// | i j k l |
// | m n o p |

export default class Matrix4x4 {
    constructor (matrix) {
        this._m = matrix ? new Float32Array(matrix._m) : new Float32Array(16);
    }

    set (mat4) {
        this._m.set(mat4._m);
        return this;
    }

    // getElement (i, j) {
    //     return this._m[i * 4 + j];
    // }

    getMatrixArray () {
        return this._m;
    }

    setToIdentity () {
        this._m[0] = 1;
        this._m[1] = 0;
        this._m[2] = 0;
        this._m[3] = 0;
        this._m[4] = 0;
        this._m[5] = 1;
        this._m[6] = 0;
        this._m[7] = 0;
        this._m[8] = 0;
        this._m[9] = 0;
        this._m[10] = 1;
        this._m[11] = 0;
        this._m[12] = 0;
        this._m[13] = 0;
        this._m[14] = 0;
        this._m[15] = 1;
        return this;
    }

    setMatrix (arrayMatrix) {
        if (arrayMatrix.length === 9) {
            // We suppose arrayMatrix corresponds to a 3x3 matrix
            this._m[0] = arrayMatrix[0];
            this._m[1] = arrayMatrix[1];
            this._m[2] = arrayMatrix[2];
            this._m[3] = 0;
            this._m[4] = arrayMatrix[3];
            this._m[5] = arrayMatrix[4];
            this._m[6] = arrayMatrix[5];
            this._m[7] = 0;
            this._m[8] = arrayMatrix[6];
            this._m[9] = arrayMatrix[7];
            this._m[10] = arrayMatrix[8];
            this._m[11] = 0;
            this._m[12] = 0;
            this._m[13] = 0;
            this._m[14] = 0;
            this._m[15] = 1;
            return this;
        }

        this._m[0] = arrayMatrix[0];
        this._m[1] = arrayMatrix[1];
        this._m[2] = arrayMatrix[2];
        this._m[3] = arrayMatrix[3];
        this._m[4] = arrayMatrix[4];
        this._m[5] = arrayMatrix[5];
        this._m[6] = arrayMatrix[6];
        this._m[7] = arrayMatrix[7];
        this._m[8] = arrayMatrix[8];
        this._m[9] = arrayMatrix[9];
        this._m[10] = arrayMatrix[10];
        this._m[11] = arrayMatrix[11];
        this._m[12] = arrayMatrix[12];
        this._m[13] = arrayMatrix[13];
        this._m[14] = arrayMatrix[14];
        this._m[15] = arrayMatrix[15];
        return this;
    }

    // Operations modifying the matrix
    // addScalar (s) {
    //     this._m[0] += s;
    //     this._m[1] += s;
    //     this._m[2] += s;
    //     this._m[3] += s;
    //     this._m[4] += s;
    //     this._m[5] += s;
    //     this._m[6] += s;
    //     this._m[7] += s;
    //     this._m[8] += s;
    //     this._m[9] += s;
    //     this._m[10] += s;
    //     this._m[11] += s;
    //     this._m[12] += s;
    //     this._m[13] += s;
    //     this._m[14] += s;
    //     this._m[15] += s;
    //     return this;
    // }

    add (mat) {
        var m = mat._m;
        this._m[0] += m[0];
        this._m[1] += m[1];
        this._m[2] += m[2];
        this._m[3] += m[3];
        this._m[4] += m[4];
        this._m[5] += m[5];
        this._m[6] += m[6];
        this._m[7] += m[7];
        this._m[8] += m[8];
        this._m[9] += m[9];
        this._m[10] += m[10];
        this._m[11] += m[11];
        this._m[12] += m[12];
        this._m[13] += m[13];
        this._m[14] += m[14];
        this._m[15] += m[15];
        return this;
    }

    addition (mat) {
        return new Matrix4x4(this).add(mat);
    }

    // subtractScalar (s) {
    //     this._m[0] -= s;
    //     this._m[1] -= s;
    //     this._m[2] -= s;
    //     this._m[3] -= s;
    //     this._m[4] -= s;
    //     this._m[5] -= s;
    //     this._m[6] -= s;
    //     this._m[7] -= s;
    //     this._m[8] -= s;
    //     this._m[9] -= s;
    //     this._m[10] -= s;
    //     this._m[11] -= s;
    //     this._m[12] -= s;
    //     this._m[13] -= s;
    //     this._m[14] -= s;
    //     this._m[15] -= s;
    //     return this;
    // }

    multiplyScalar (s) {
        this._m[0] *= s;
        this._m[1] *= s;
        this._m[2] *= s;
        this._m[3] *= s;
        this._m[4] *= s;
        this._m[5] *= s;
        this._m[6] *= s;
        this._m[7] *= s;
        this._m[8] *= s;
        this._m[9] *= s;
        this._m[10] *= s;
        this._m[11] *= s;
        this._m[12] *= s;
        this._m[13] *= s;
        this._m[14] *= s;
        this._m[15] *= s;
        return this;
    }

    // divideScalar (s) {
    //     this._m[0] /= s;
    //     this._m[1] /= s;
    //     this._m[2] /= s;
    //     this._m[3] /= s;
    //     this._m[4] /= s;
    //     this._m[5] /= s;
    //     this._m[6] /= s;
    //     this._m[7] /= s;
    //     this._m[8] /= s;
    //     this._m[9] /= s;
    //     this._m[10] /= s;
    //     this._m[11] /= s;
    //     this._m[12] /= s;
    //     this._m[13] /= s;
    //     this._m[14] /= s;
    //     this._m[15] /= s;
    //     return this;
    // }

    transpose () {
        var b = this._m[4];
        var c = this._m[8];
        var d = this._m[12];
        var g = this._m[9];
        var h = this._m[13];
        var l = this._m[14];

        this._m[4]  = this._m[1];
        this._m[8]  = this._m[2];
        this._m[9]  = this._m[6];
        this._m[12] = this._m[3];
        this._m[13] = this._m[7];
        this._m[14] = this._m[11];

        this._m[1]  = b;
        this._m[2]  = c;
        this._m[3]  = d;
        this._m[6]  = g;
        this._m[7]  = h;
        this._m[11] = l;
        return this;
    }

    invert () {
        var a = this._m[0];
        var b = this._m[1];
        var c = this._m[2];
        var d = this._m[3];
        var e = this._m[4];
        var f = this._m[5];
        var g = this._m[6];
        var h = this._m[7];
        var i = this._m[8];
        var j = this._m[9];
        var k = this._m[10];
        var l = this._m[11];
        var m = this._m[12];
        var n = this._m[13];
        var o = this._m[14];
        var p = this._m[15];

        var A = a * f - e * b;
        var B = a * j - i * b;
        var t = a * n - m * b;
        var u = e * j - i * f;
        var v = e * n - m * f;
        var w = i * n - m * j;
        var x = c * h - g * d;
        var y = c * l - k * d;
        var z = c * p - o * d;
        var C = g * l - k * h;
        var D = g * p - o * h;
        var E = k * p - o * l;
        var q = 1 / (A * E - B * D + t * C + u * z - v * y + w * x);

        this._m[0]  = (f * E - j * D + n * C) * q;
        this._m[1]  = (-b * E + j * z - n * y) * q;
        this._m[2]  = (b * D - f * z + n * x) * q;
        this._m[3]  = (-b * C + f * y - j * x) * q;
        this._m[4]  = (-e * E + i * D - m * C) * q;
        this._m[5]  = (a * E - i * z + m * y) * q;
        this._m[6]  = (-a * D + e * z - m * x) * q;
        this._m[7]  = (a * C - e * y + i * x) * q;
        this._m[8]  = (h * w - l * v + p * u) * q;
        this._m[9]  = (-d * w + l * t - p * B) * q;
        this._m[10] = (d * v - h * t + p * A) * q;
        this._m[11] = (-d * u + h * B - l * A) * q;
        this._m[12] = (-g * w + k * v - o * u) * q;
        this._m[13] = (c * w - k * t + o * B) * q;
        this._m[14] = (-c * v + g * t - o * A) * q;
        this._m[15] = (c * u - g * B + k * A) * q;
        return this;
    }

    translate (translation, sign = 1) {
        var x = sign * translation.x;
        var y = sign * translation.y;
        var z = sign * translation.z;

        this._m[12] += this._m[0] * x + this._m[4] * y + this._m[8]  * z;
        this._m[13] += this._m[1] * x + this._m[5] * y + this._m[9]  * z;
        this._m[14] += this._m[2] * x + this._m[6] * y + this._m[10] * z;
        this._m[15] += this._m[3] * x + this._m[7] * y + this._m[11] * z;
        return this;
    }

    scale (scale) {
        var x = scale.x;
        if (x !== 1) {
            this._m[0] *= x;
            this._m[1] *= x;
            this._m[2] *= x;
            this._m[3] *= x;
        }

        var y = scale.y;
        if (y !== 1) {
            this._m[4] *= y;
            this._m[5] *= y;
            this._m[6] *= y;
            this._m[7] *= y;
        }

        var z = scale.z;
        if (z !== 1) {
            this._m[8]  *= z;
            this._m[9]  *= z;
            this._m[10] *= z;
            this._m[11] *= z;
        }

        return this;
    }

    rotate (rotation, rotationAxis) {
        if (rotation === 0) {
            // No rotation
            return this;
        }

        var x = rotationAxis.x;
        var y = rotationAxis.y;
        var z = rotationAxis.z;
        var length = Math.sqrt(x * x + y * y + z * z);
        if (length === 0) {
            // No rotation axis
            return this;
        }

        if (length != 1) {
            // normalisation
            x /= length;
            y /= length;
            z /= length;
        }

        var sin = Math.sin(rotation);
        var cos = Math.cos(rotation);
        var oneMinusCos = 1 - cos;

        var a = this._m[0];
        var b = this._m[4];
        var c = this._m[8];
        var e = this._m[1];
        var f = this._m[5];
        var g = this._m[9];
        var i = this._m[2];
        var j = this._m[6];
        var k = this._m[10];
        var m = this._m[3];
        var n = this._m[7];
        var o = this._m[11];

        // Components of the 3x3 rotation matrix
        var ra = x * x * oneMinusCos + cos;
        var rb = y * x * oneMinusCos - z * sin;
        var rc = z * x * oneMinusCos + y * sin;
        var rd = x * y * oneMinusCos + z * sin;
        var re = y * y * oneMinusCos + cos;
        var rf = z * y * oneMinusCos - x * sin;
        var rg = x * z * oneMinusCos - y * sin;
        var rh = y * z * oneMinusCos + x * sin;
        var ri = z * z * oneMinusCos + cos;

        this._m[0]  = a * ra + b * rd + c * rg;
        this._m[1]  = e * ra + f * rd + g * rg;
        this._m[2]  = i * ra + j * rd + k * rg;
        this._m[3]  = m * ra + n * rd + o * rg;
        this._m[4]  = a * rb + b * re + c * rh;
        this._m[5]  = e * rb + f * re + g * rh;
        this._m[6]  = i * rb + j * re + k * rh;
        this._m[7]  = m * rb + n * re + o * rh;
        this._m[8]  = a * rc + b * rf + c * ri;
        this._m[9]  = e * rc + f * rf + g * ri;
        this._m[10] = i * rc + j * rf + k * ri;
        this._m[11] = m * rc + n * rf + o * ri;
        return this;
    }

    rotateX (rotation) {
        if (rotation === 0) {
            // No rotation
            return this;
        }

        var sin = Math.sin(rotation);
        var cos = Math.cos(rotation);

        var b = this._m[4];
        var c = this._m[8];
        var f = this._m[5];
        var g = this._m[9];
        var j = this._m[6];
        var k = this._m[10];
        var n = this._m[7];
        var o = this._m[11];

        this._m[4]  = b * cos + c * sin;
        this._m[8]  = c * cos - b * sin;
        this._m[5]  = f * cos + g * sin;
        this._m[9]  = g * cos - f * sin;
        this._m[6]  = j * cos + k * sin;
        this._m[10] = k * cos - j * sin;
        this._m[7]  = n * cos + o * sin;
        this._m[11] = o * cos - n * sin;
        return this;
    }

    rotateY (rotation) {
        if (rotation === 0) {
            // No rotation
            return this;
        }

        var sin = Math.sin(rotation);
        var cos = Math.cos(rotation);

        var a = this._m[0];
        var c = this._m[8];
        var e = this._m[1];
        var g = this._m[9];
        var i = this._m[2];
        var k = this._m[10];
        var m = this._m[3];
        var o = this._m[11];

        this._m[0]  = a * cos - c * sin;
        this._m[8]  = c * cos + a * sin;
        this._m[1]  = e * cos - g * sin;
        this._m[9]  = g * cos + e * sin;
        this._m[2]  = i * cos - k * sin;
        this._m[10] = k * cos + i * sin;
        this._m[3]  = m * cos - o * sin;
        this._m[11] = o * cos + m * sin;
        return this;
    }

    rotateZ (rotation) {
        if (rotation === 0) {
            // No rotation
            return this;
        }

        var sin = Math.sin(rotation);
        var cos = Math.cos(rotation);

        var a = this._m[0];
        var b = this._m[4];
        var e = this._m[1];
        var f = this._m[5];
        var i = this._m[2];
        var j = this._m[6];
        var m = this._m[3];
        var n = this._m[7];

        this._m[0] = a * cos + b * sin;
        this._m[4] = b * cos - a * sin;
        this._m[1] = e * cos + f * sin;
        this._m[5] = f * cos - e * sin;
        this._m[2] = i * cos + j * sin;
        this._m[6] = j * cos - i * sin;
        this._m[3] = m * cos + n * sin;
        this._m[7] = n * cos - m * sin;
        return this;
    }

    // rotateQuaternion (rotq) {
    //     var angle = 2 * Math.acos(rotq.w);
    //     var axis  = new Vector3(rotq.x, rotq.y, rotq.z).multiplyScalar(1 / Math.sin(angle / 2));
    //     return this.rotate(angle, axis);
    // }

    multiply (mat4) {
        var m = mat4._m;

        var a0 = this._m[0];
        var b0 = this._m[4];
        var c0 = this._m[8];
        var d0 = this._m[12];
        var e0 = this._m[1];
        var f0 = this._m[5];
        var g0 = this._m[9];
        var h0 = this._m[13];
        var i0 = this._m[2];
        var j0 = this._m[6];
        var k0 = this._m[10];
        var l0 = this._m[14];
        var m0 = this._m[3];
        var n0 = this._m[7];
        var o0 = this._m[11];
        var p0 = this._m[15];

        var a1 = m[0];
        var b1 = m[4];
        var c1 = m[8];
        var d1 = m[12];
        var e1 = m[1];
        var f1 = m[5];
        var g1 = m[9];
        var h1 = m[13];
        var i1 = m[2];
        var j1 = m[6];
        var k1 = m[10];
        var l1 = m[14];
        var m1 = m[3];
        var n1 = m[7];
        var o1 = m[11];
        var p1 = m[15];

        this._m[0]  = a1 * a0 + e1 * b0 + i1 * c0 + m1 * d0;
        this._m[4]  = b1 * a0 + f1 * b0 + j1 * c0 + n1 * d0;
        this._m[8]  = c1 * a0 + g1 * b0 + k1 * c0 + o1 * d0;
        this._m[12] = d1 * a0 + h1 * b0 + l1 * c0 + p1 * d0;

        this._m[1]  = a1 * e0 + e1 * f0 + i1 * g0 + m1 * h0;
        this._m[5]  = b1 * e0 + f1 * f0 + j1 * g0 + n1 * h0;
        this._m[9]  = c1 * e0 + g1 * f0 + k1 * g0 + o1 * h0;
        this._m[13] = d1 * e0 + h1 * f0 + l1 * g0 + p1 * h0;

        this._m[2]  = a1 * i0 + e1 * j0 + i1 * k0 + m1 * l0;
        this._m[6]  = b1 * i0 + f1 * j0 + j1 * k0 + n1 * l0;
        this._m[10] = c1 * i0 + g1 * j0 + k1 * k0 + o1 * l0;
        this._m[14] = d1 * i0 + h1 * j0 + l1 * k0 + p1 * l0;

        this._m[3]  = a1 * m0 + e1 * n0 + i1 * o0 + m1 * p0;
        this._m[7]  = b1 * m0 + f1 * n0 + j1 * o0 + n1 * p0;
        this._m[11] = c1 * m0 + g1 * n0 + k1 * o0 + o1 * p0;
        this._m[15] = d1 * m0 + h1 * n0 + l1 * o0 + p1 * p0;
        return this;
    }

    // Operations creating a new matrix

    // transposition () {
    //     return new Matrix4x4(this).transpose();
    // }

    inverse () {
        return new Matrix4x4(this).invert();
    }

    // additionScalar (s) {
    //     return new Matrix4x4(this).addScalar(s);
    // }

    // subtractionScalar (s) {
    //     return new Matrix4x4(this).subtractScalar(s);
    // }

    multiplicationScalar (s) {
        return new Matrix4x4(this).multiplyScalar(s);
    }

    // divisionScalar (s) {
    //     return new Matrix4x4(this).divideScalar(s);
    // }

    multiplication (mat4) {
        return new Matrix4x4(this).multiply(mat4);
    }

    translation (translation) {
        return new Matrix4x4(this).translate(translation);
    }

    scaling (scale) {
        return new Matrix4x4(this).scale(scale);
    }

    rotation (rotation, vec3Axis) {
        return new Matrix4x4(this).rotate(rotation, vec3Axis);
    }

    rotationX (rotation) {
        return new Matrix4x4(this).rotateX(rotation);
    }

    rotationY (rotation) {
        return new Matrix4x4(this).rotateY(rotation);
    }

    rotationZ (rotation) {
        return new Matrix4x4(this).rotateZ(rotation);
    }

    multiplyVector3 (vec3) {
        var x0 = vec3.x;
        var y0 = vec3.y;
        var z0 = vec3.z;

        var x1 = this._m[0] * x0 + this._m[4] * y0 + this._m[8]  * z0 + this._m[12];
        var y1 = this._m[1] * x0 + this._m[5] * y0 + this._m[9]  * z0 + this._m[13];
        var z1 = this._m[2] * x0 + this._m[6] * y0 + this._m[10] * z0 + this._m[14];
        return new Vector3(x1, y1, z1);
    }

    multiplyVector4 (vec4) {
        var x0 = vec4.x;
        var y0 = vec4.y;
        var z0 = vec4.z;
        var w0 = vec4.w;

        var x1 = this._m[0] * x0 + this._m[4] * y0 + this._m[8]  * z0 + this._m[12] * w0;
        var y1 = this._m[1] * x0 + this._m[5] * y0 + this._m[9]  * z0 + this._m[13] * w0;
        var z1 = this._m[2] * x0 + this._m[6] * y0 + this._m[10] * z0 + this._m[14] * w0;
        var w1 = this._m[3] * x0 + this._m[7] * y0 + this._m[11] * z0 + this._m[15] * w0;

        return new Vector4(x1, y1, z1, w1);
    }

    determinant () {
        var a = this._m[0];
        var b = this._m[4];
        var c = this._m[8];
        var d = this._m[12];
        var e = this._m[1];
        var f = this._m[5];
        var g = this._m[9];
        var h = this._m[13];
        var i = this._m[2];
        var j = this._m[6];
        var k = this._m[10];
        var l = this._m[14];
        var m = this._m[3];
        var n = this._m[7];
        var o = this._m[11];
        var p = this._m[15];
        return m * j * g * d - i * n * g * d - m * f * k * d + e * n * k * d + i * f * o * d - e * j * o * d - m * j * c * h + i * n * c * h + m * b * k * h - a * n * k * h - i * b * o * h + a * j * o * h + m * f * c * l - e * n * c * l - m * b * g * l + a * n * g * l + e * b * o * l - a * f * o * l - i * f * c * p + e * j * c * p + i * b * g * p - a * j * g * p - e * b * k * p + a * f * k * p;
    }

    decompose () {
        var vector = new Vector3();

        var m = this._m;

        var sx = vector.set(m[0], m[1], m[2] ).length();
        var sy = vector.set(m[4], m[5], m[6] ).length();
        var sz = vector.set(m[8], m[9], m[10]).length();

        // if determinant is negative, we need to invert one scale
        if (this.determinant() < 0) sx = -sx;

        // scale the rotation part

        var invSX = 1 / sx;
        var invSY = 1 / sy;
        var invSZ = 1 / sz;

        var matrix = this.copy();

        matrix._m[0]  *= invSX;
        matrix._m[1]  *= invSX;
        matrix._m[2]  *= invSX;

        matrix._m[4]  *= invSY;
        matrix._m[5]  *= invSY;
        matrix._m[6]  *= invSY;

        matrix._m[8]  *= invSZ;
        matrix._m[9]  *= invSZ;
        matrix._m[10] *= invSZ;

        return {
            position: new Vector3(m[12], m[13], m[14]),
            rotation: new Quaternion().setFromRotationMatrix(matrix),
            scale:    new Vector3(sx, sy, sz)
        };
    }

    setOrthogonalProjection (left, right, bottom, top, near, far) {
        this._m[0]  = 2 / (right - left);
        this._m[4]  = 0;
        this._m[8]  = 0;
        this._m[12] = -(right + left) / (right - left);
        this._m[1]  = 0;
        this._m[5]  = 2 / (top - bottom);
        this._m[9]  = 0;
        this._m[13] = -(top + bottom) / (top - bottom);
        this._m[2]  = 0;
        this._m[6]  = 0;
        this._m[10] = -2 / (far - near);
        this._m[14] = -(far + near) / (far - near);
        this._m[3]  = 0;
        this._m[7]  = 0;
        this._m[11] = 0;
        this._m[15] = 1;
        return this;
    }

    setPerspectiveProjection (fov, aspect, near, far) {
        var heightOver2 = near * Math.tan(fov * 0.5);
        var widthOver2  = heightOver2 * aspect;
        return this.setFrustumProjection(-widthOver2, widthOver2, -heightOver2, heightOver2, near, far);
    }

    setFrustumProjection (left, right, bottom, top, near, far) {
        var dx = right - left;
        var dy = top - bottom;
        var dz = far - near;

        this._m[0]  = 2 * near / dx;
        this._m[4]  = 0;
        this._m[8]  = (right + left) / dx;
        this._m[12] = 0;
        this._m[1]  = 0;
        this._m[5]  = 2 * near / dy;
        this._m[9]  = (top + bottom) / dy;
        this._m[13] = 0;
        this._m[2]  = 0;
        this._m[6]  = 0;
        this._m[10] = -(far + near) / dz;
        this._m[14] = -(2 * far * near) / dz;
        this._m[3]  = 0;
        this._m[7]  = 0;
        this._m[11] = -1;
        this._m[15] = 0;
        return this;
    }

    // setAspect (aspect) {
    //     var x = aspect.x;
    //     var y = aspect.y;

    //     this._m[0]  *= x;
    //     this._m[4]  *= x;
    //     this._m[8]  *= x;
    //     this._m[12] *= x;

    //     this._m[1]  *= y;
    //     this._m[5]  *= y;
    //     this._m[9]  *= y;
    //     this._m[13] *= y;
    //     return this;
    // }

    // withAspect (aspect) {
    //     return new Matrix4x4(this).setAspect(aspect);
    // }

    setAspectRatio (aspectRatio) {
        this._m[0]  *= aspectRatio;
        this._m[4]  *= aspectRatio;
        this._m[8]  *= aspectRatio;
        this._m[12] *= aspectRatio;
        return this;
    }

    withAspectRatio (aspectRatio) {
        return new Matrix4x4(this).setAspectRatio(aspectRatio);
    }

    // setView2 (from, to, up) {
    //     var x = from.x;
    //     var y = from.y;
    //     var z = from.z;

    //     // Computing z axis
    //     var zx = x - to.x;
    //     var zy = y - to.y;
    //     var zz = z - to.z;

    //     var zLength = Math.sqrt(zx * zx + zy * zy + zz * zz);
    //     if (zLength < 1e-5) {
    //         zz = 1;
    //     } else {
    //         zx /= zLength;
    //         zy /= zLength;
    //         zz /= zLength;
    //     }

    //     // Computing x axis
    //     var xUp = up.x;
    //     var yUp = up.y;
    //     var zUp = up.z;

    //     var xx = yUp * zz - zUp * zy;
    //     var xy = zUp * zx - xUp * zz;
    //     var xz = xUp * zy - yUp * zx;

    //     var xLength = Math.sqrt(xx * xx + xy * xy + xz * xz);
    //     if (xLength < 1e-5) {
    //         xx = 1;
    //     } else {
    //         xx /= xLength;
    //         xy /= xLength;
    //         xz /= xLength;
    //     }

    //     // Computing y axis
    //     var yx = zy * xz - zz * xy;
    //     var yy = zz * xx - zx * xz;
    //     var yz = zx * xy - zy * xx;

    //     var yLength = Math.sqrt(yx * yx + yy * yy + yz * yz);
    //     if (yLength < 1e-5) {
    //         yy = 1;
    //     } else {
    //         yx /= yLength;
    //         yy /= yLength;
    //         yz /= yLength;
    //     }

    //     this._m[0]  = xx;
    //     this._m[4]  = xy;
    //     this._m[8]  = xz;
    //     this._m[12] = -(xx * x + xy * y + xz * z);
    //     this._m[1]  = yx;
    //     this._m[5]  = yy;
    //     this._m[9]  = yz;
    //     this._m[13] = -(yx * x + yy * y + yz * z);
    //     this._m[2]  = zx;
    //     this._m[6]  = zy;
    //     this._m[10] = zz;
    //     this._m[14] = -(zx * x + zy * y + zz * z);
    //     this._m[3]  = 0;
    //     this._m[7]  = 0;
    //     this._m[11] = 0;
    //     this._m[15] = 1;
    //     return this;
    // }

    setView (from, forward, upward, rightward) {
        var x = from.x;
        var y = from.y;
        var z = from.z;

        // x axis
        var xx = rightward.x;
        var xy = rightward.y;
        var xz = rightward.z;

        // y axis
        var yx = upward.x;
        var yy = upward.y;
        var yz = upward.z;

        // z axis
        var zx = forward.x;
        var zy = forward.y;
        var zz = forward.z;

        this._m[0]  = xx;
        this._m[4]  = xy;
        this._m[8]  = xz;
        this._m[12] = -(xx * x + xy * y + xz * z);
        this._m[1]  = yx;
        this._m[5]  = yy;
        this._m[9]  = yz;
        this._m[13] = -(yx * x + yy * y + yz * z);
        this._m[2]  = -zx;
        this._m[6]  = -zy;
        this._m[10] = -zz;
        this._m[14] = (zx * x + zy * y + zz * z);
        this._m[3]  = 0;
        this._m[7]  = 0;
        this._m[11] = 0;
        this._m[15] = 1;
        return this;
    }

    copy () {
        return new Matrix4x4(this);
    }

    // toString (precision) {
    //     precision = precision || 3;
    //     var m = this._m;
    //     return '[[' + m[0].toFixed(precision) + ', ' + m[4].toFixed(precision) + ', ' + m[8].toFixed(precision)  + ', ' + m[12].toFixed(precision) + '], [' +
    //                 m[1].toFixed(precision) + ', ' + m[5].toFixed(precision) + ', ' + m[9].toFixed(precision)  + ', ' + m[13].toFixed(precision) + '], [' +
    //                 m[2].toFixed(precision) + ', ' + m[6].toFixed(precision) + ', ' + m[10].toFixed(precision) + ', ' + m[14].toFixed(precision) + '], [' +
    //                 m[3].toFixed(precision) + ', ' + m[7].toFixed(precision) + ', ' + m[11].toFixed(precision) + ', ' + m[15].toFixed(precision) + ']]';
    // }

    // equals (mat) {
    //     if (this._m.length !== mat._m.length) {
    //         return false;
    //     }
    //     for (var i = 0; i < this._m.length; i++) {
    //         if (this._m[i] !== mat._m[i]) {
    //             return false;
    //         }
    //     }
    //     return true;
    // }
}
